import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const OurCollection = () => {
  const navigate = useNavigate();

  const products = [
    {
      id: 1,
      name: 'Hermes Mini Kelly',
      price: 'NRS xxx',
      image: '/hermes.png',
      slug: 'hermes-mini-kelly'
    },
    {
      id: 2,
      name: 'White Coach',
      price: 'NRS xxx',
      image: '/whitecoach.png',
      slug: 'white-coach'
    }
  ];

  const handleProductClick = (slug: string) => {
    navigate(`/product/${slug}`);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-white via-cream-50 to-gold-50 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-4 w-20 h-20 border border-gold-200 rounded-full"></div>
        <div className="absolute bottom-20 right-6 w-16 h-16 bg-gold-100 rounded-full"></div>
        <div className="absolute top-1/2 left-8 w-2 h-2 bg-gold-300 rounded-full"></div>
        <div className="absolute top-1/4 right-12 w-3 h-3 bg-gold-200 rounded-full"></div>
      </div>

      <div className="px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center">
              <SparklesIcon className="h-5 w-5 text-gold-500 mr-2" />
              <div className="w-12 h-px bg-gradient-to-r from-transparent via-gold-400 to-transparent"></div>
              <div className="w-3 h-3 bg-gold-400 rounded-full mx-4 animate-pulse"></div>
              <div className="w-12 h-px bg-gradient-to-r from-transparent via-gold-400 to-transparent"></div>
              <SparklesIcon className="h-5 w-5 text-gold-500 ml-2" />
            </div>
          </div>

          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4 tracking-wide">
            Our Exclusive
            <span className="block text-gradient text-4xl">Collection</span>
          </h2>
        </motion.div>

        {/* Products Grid - Gucci Style */}
        <div className="grid grid-cols-2 gap-4 max-w-md mx-auto">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="cursor-pointer group"
              onClick={() => handleProductClick(product.slug)}
            >
              {/* Clean Product Card */}
              <div className="bg-white rounded-2xl overflow-hidden luxury-shadow hover-lift">
                {/* Product Image */}
                <div className="aspect-square overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Product Info */}
                <div className="p-4 text-center">
                  <h3 className="font-serif font-semibold text-gray-900 mb-1 text-sm">
                    {product.name}
                  </h3>
                  <p className="text-gray-900 font-bold text-lg">
                    {product.price}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Footer Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-sm text-gray-600 font-light">
            Click any product to view details
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default OurCollection;